import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const Logout = () => {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {

    logout();


    navigate('/');
  }, [logout, navigate]);

  return (
    <div className="container py-5 text-center">
      <div className="spinner-border" role="status">
        <span className="visually-hidden">جاري تسجيل الخروج...</span>
      </div>
      <p className="mt-3">جاري تسجيل الخروج...</p>
    </div>
  );
};

export default Logout;
